import React from "react"
import {
  List,
  Divider,
  Label,
  Card,
  Container,
  Button
} from "semantic-ui-react"
import { ConfirmModal } from "uikit"

export const PlanCard = ({
  planId,
  features,
  amount,
  free_trial_days,
  name,
  description,
  isFeatured,
  interval,
  nonfeatures,
  onSelect,
  variant,
  selected
}) => {
  let availableFeatures = features.map((feature, index) => (
    <List.Item key={`A${index}`}>
      <List.Icon color="green" name="checkmark" />
      <List.Content>{feature}</List.Content>
    </List.Item>
  ))

  let unavailableFeatures = nonfeatures.map((feature, index) => (
    <List.Item key={`U${index}`}>
      <List.Icon color="red" name="remove" />
      <List.Content>{feature}</List.Content>
    </List.Item>
  ))

  let featureList = availableFeatures.concat(unavailableFeatures)
  let subscriptionFee =
    interval === "yearly" ? (
      <Divider horizontal>${amount}/ YEAR</Divider>
    ) : interval === "monthly" ? (
      <Divider horizontal>${amount}/ MONTH</Divider>
    ) : (
      <Divider horizontal>{amount}</Divider>
    )
  if (free_trial_days) {
    subscriptionFee = (
      <>
        {subscriptionFee}
        <div
          style={{
            color: "#00adef",
            fontWeight: "600",
            textTransform: "uppercase",
            textAlign: "center",
            marginTop: "-10px",
            marginBottom: "1em"
          }}
        >
          after {free_trial_days} day free trial
        </div>
      </>
    )
  } else {
    subscriptionFee = (
      <>
        {subscriptionFee}
        <div
          style={{
            marginTop: "-10px",
            marginBottom: "1em"
          }}
        >
          &nbsp;
        </div>
      </>
    )
  }
  let featuedFlag = isFeatured ? (
    <Label corner="left" color="blue" icon="asterisk" />
  ) : (
    ""
  )
  return (
    <Card centered>
      <Card.Content>
        {featuedFlag}
        <Card.Header style={{ textAlign: "center" }} content={name} as="h1" />
        <Card.Meta
          style={{
            textAlign: "center",
            paddingLeft: "2em",
            paddingRight: "2em"
          }}
        >
          {description}
        </Card.Meta>
        {subscriptionFee}
        <Card.Description>
          <Container textAlign="left">
            <List>{featureList}</List>
          </Container>
        </Card.Description>
        <Divider />
        <Container textAlign="center">
          {variant === "canceled" ? (
            <span style={{ color: "red", fontWeight: "bold" }}>CANCELED</span>
          ) : variant === "unsubscribe" ? (
            <ConfirmModal
              buttonLabel="Unsubscribe"
              onConfirm={onSelect}
              success={
                <p style={{ color: "#ddd", paddingTop: "8px" }}>
                  Unsubscribing...
                </p>
              }
              failure={error => (
                <p style={{ color: "red", paddingTop: "8px" }}>
                  {error.message}
                </p>
              )}
              header="Are You Sure?"
              description={
                <span>
                  If you proceed, you will cancel your subscription. Your
                  account will remain active until the end of the your paid
                  subscription period.
                </span>
              }
              data-testid={planId}
            />
          ) : (
            <Button
              color={variant === "unsubscribe" ? "red" : "blue"}
              basic={
                variant === "unsubscribe" ||
                variant === "resubscribe" ||
                variant === "downgrade"
              }
              type="button"
              onClick={onSelect}
              content={
                variant === "unsubscribe"
                  ? "Unsubscribe"
                  : variant === "upgrade"
                  ? "Upgrade"
                  : variant === "resubscribe"
                  ? "Resubscribe"
                  : variant === "downgrade"
                  ? "Downgrade"
                  : "Select"
              }
              data-testid={planId}
            />
          )}
        </Container>
      </Card.Content>
    </Card>
  )
}
